import _ from "lodash"

export function getClusterLayerConfig(config) {
    const baseConfig = {
        type: "circle",
        filter: ["has", "point_count"],
    }
    return _.merge(baseConfig, config)
}